import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { pulseCheckTheme } from './PulseCheck.meta';
import { isConsumerArea, selectHasPulseCheck } from '../CommonSelectors/CommonAreaSelector';
import { useFeatureFlag } from '../_hooks/useFeatureFlag';
import { Feature } from '../CommonSelectors/CommonArea.types';
import { ClientFooter } from '../ConsumerArea/components/Footer/FooterView';

export const PulseCheckWrapper = ({ children }) => {
  const hasPulseCheck = useSelector(selectHasPulseCheck);
  const isPulseCheckEnabled = useFeatureFlag(Feature.PulseCheck);

  const isClient = useSelector(isConsumerArea);

  if (!isPulseCheckEnabled || !hasPulseCheck) {
    throw new Error('PulseCheck is not enabled');
  }

  return (
    <ThemeProvider theme={pulseCheckTheme}>
      {children}

      {isClient && <ClientFooter />}
    </ThemeProvider>
  );
};
